exports.en = {
  UNIFORM_DETAIL: {
    DROPDOWN: 'Choose item...',
    INVALID_INPUT: 'Error.',
    INVALID_CHECKBOX: 'Please choose.',
    INVALID_RADIO: 'Please choose.',
    INVALID_TEXTAREA: 'Error.',
    INVALID_COMBOBOX: 'Please choose.',
    INVALID_POBOCKY: 'Please choose.',
    INVALID_FILE: 'Select a file from your device.',
    FILES_EXCEEDED: 'Max files count exceeded. This files where not uploaded: ',
    FILE_UPLOAD: 'Choose a file',
    FILES_UPLOADED: 'You added %{filesAdded} files',
    FILES_UPLOADED2: 'You added %{filesAdded} files',
    DELETE_FILES: 'Delete files',
    INVALID_DATEPICKER: 'Enter the date in the required format.',
    ATTACHMENT_INVALIDEXTENSION: 'The selected file is not in the required format.',
    ATTACHMENT_MAXSIZEEXCEEDED: 'File exceeded maximum allowed size',
    ATTACHMENT_MAXFILENAMELENGTHEXCEEDED: 'Maximum filename length is 50 characters. Please shorten it.',
    ATTACHMENT_MAX_TIME_EXCEEDED: 'The upload time exceeded the allowed limit.',
    ERROR_FORM: 'Error opening form.',
    ERROR_REQUIRED: 'Please fill in.',
    ERROR_PATTERN: 'Wrong format.',
    ERROR_MINLENGTH: 'Required minimum length.',
    ERROR_MAXLENGTH: 'Required maximum length.',
    FORM_NOT_VALID: 'The form can not be sent. Have you filled everything up correctly?',
    INVALID_BIRTHNUMBER_MODULO: 'You entered your birth number in the wrong format.',
    POBOCKY_PLACEHOLDER: 'Please choose...',
    POBOCKY_NO_RESULTS: 'No results found.',
    ERROR_BACKEND: 'We apologise, but the form is momentarily unavailable. Please contact us toll free on 800 207 207.',
    STEPS: {
      BUTTON_PREVIOUS: 'Previous step',
      BUTTON_NEXT: 'Next step'
    }
  }
}
